import React, {useContext, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {useWeb3React as useWeb3ReactCore} from '@web3-react/core'
import {InjectedConnector} from '@web3-react/injected-connector';
import Head from '../components/donate/Head'
import Back from '../components/donate/Back'
import Content from '../components/donate/Content'
import ProgressBox from '../components/donate/ProgressBox'
import SupportSubjectModel from '../components/model/SupportSubjectModel'
import InputAmountModel from '../components/model/InputAmountModel'
import SuccessModel from '../components/model/SuccessModel'
import styled from 'styled-components';
import BaseBtn from '../components/common/styled/BaseBtn'
import {TRIAS_SELECTED_WEB3_CONTEXT,THIS_CHAIN_ID} from "../const";
import {mainContext} from "../reducer";
import Loader from "../components/common/Loading";

const ContStyle = styled.div`
  width: 1080px;
  margin: auto;
  font-size: 20px;
  .support-btn {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 40px;
    flex-wrap: wrap;
  }
  .study {
    margin-top: 15px;
    p {
      margin-bottom: 5px;
    }
    ul {
      list-style: disc;
      padding-left: 20px;
      a:hover {
        color: #000;
      }
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
    .support-btn {
      justify-content: center;
    }
  }
`;

const W66 = styled.div`
  width: 66.6%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default function Donate() {
  const dispatch = useDispatch();
  const {active, activate, account, chainId} = useWeb3ReactCore()
  const supportSubjectModel = useSelector(state => state.supportSubjectModel);
  const donateSuccessModel = useSelector(state => state.donateSuccessModel);

  const {transactions} = useContext(mainContext).state
  const approving = transactions.find((item) => {
    return (
        item.approve &&
        item.approve.status === 0 &&
        item.approve.account === account
    )
  })

  const staking = transactions.find((item) => {
    return (
        item.stake &&
        account === item.stake.account &&
        item.stake.status === 0
    )
  })

  const toggleSupportSubjectModel = () => {
    if (active) {
      if(chainId !== THIS_CHAIN_ID && THIS_CHAIN_ID===56){
        if (window.ethereum) {
          window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: `0x${(56).toString(16)}`,
                chainName: 'Binance Smart Chain',
                nativeCurrency: {
                  name: 'BNB',
                  symbol: 'BNB',
                  decimals: 18
                },
                rpcUrls: ['https://bsc-dataseed3.binance.org',
                  'https://bsc-dataseed1.binance.org',
                  'https://bsc-dataseed2.binance.org'],
                blockExplorerUrls: ['https://bscscan.com']
              }
            ]
          })
        }

      }else {
        dispatch({type: 'TOGGLE_SUPORT_SUBJECT_MODEL'});
      }
    } else {
      const injected = new InjectedConnector({
        supportedChainIds: [1, 3, 4, 5, 42, 66, 128, 137],
      });
      activate(injected)
          .then(() => {
            window && window.localStorage.setItem(
                TRIAS_SELECTED_WEB3_CONTEXT,
                'MetaMask'
            );
            console.log('connected')
          })
          .catch((e) => {
            console.log('connect error', e)
          });
    }
  }

  const [inputModel, setInputModel] = useState(false);
  const toggleInputModel = () => {
    setInputModel(!inputModel);
  }

  const [successModel, setSuccessModel] = useState(false);
  const toggleSuccessModel = () => {
    setSuccessModel(!successModel);
  }

  const toggledonateSuccessModel = () => {
    dispatch({type: 'DONATE_SUCCESS_MODEL'});
  }

  return (
      <>
        <Head></Head>
        <ContStyle>
          <W66>
            <Back></Back>
          </W66>
          <div class="alert alert-primary study" role="alert">
            <p>The Grant reached the hardcap on May 24. Following are the progress of the research:</p>
            <ul>
              <li>
                <a className="alert-link"
                  target="_blank"
                  href="https://triaslab.medium.com/study-on-the-quadratic-voting-grant-model-1-6b7b67123463">
                  Study on the Quadratic Voting Grant Model (1)
                </a>
              </li>
              <li>
                <a className="alert-link"
                  target="_blank"
                  href="https://triaslab.medium.com/study-on-the-quadratic-voting-grant-model-2-f9262636116d">
                  Study on the Quadratic Voting Grant Model (2)
                </a>
              </li>
            </ul>
          </div>
          <Content>
            <div className="support-btn">
              <BaseBtn disabled={true || approving || staking} width="200px" heigth="52px"
                       onClick={toggleSupportSubjectModel}>
                Stake
                {/* {active ? chainId !== THIS_CHAIN_ID ? 'Switch to BSC' : approving ? 'Approve' : staking ? 'Granting' : 'Support' : 'Connect'} */}
                {(approving || staking) && <Loader />}
              </BaseBtn>
              <ProgressBox realnumber="1345678" progress="50" total="10,000,000"></ProgressBox>
            </div>
          </Content>
        </ContStyle>
        <SupportSubjectModel
            toSupport={toggleInputModel}
            show={supportSubjectModel}
            onHide={toggleSupportSubjectModel}
        >
        </SupportSubjectModel>
        <InputAmountModel key='1' show={inputModel} onHide={toggleInputModel}></InputAmountModel>
        <SuccessModel key='2' show={successModel} onHide={toggleSuccessModel}>xxx TRIAS has been successfully
          staked.</SuccessModel>
        <SuccessModel key='3' show={donateSuccessModel} onHide={toggledonateSuccessModel}>Congratulations！You will get the memorial NFT after the grant.</SuccessModel>
      </>
  )
}
